module.exports = __webpack_public_path__ + "static/img/01.b14a62d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/01.png
// module id = ViYY
// module chunks = 0